/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { IDelegation, IDelegationInterface } from "../IDelegation";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_id",
        type: "bytes32",
      },
    ],
    name: "clearDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_id",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_delegate",
        type: "address",
      },
    ],
    name: "setDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IDelegation__factory {
  static readonly abi = _abi;
  static createInterface(): IDelegationInterface {
    return new Interface(_abi) as IDelegationInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): IDelegation {
    return new Contract(address, _abi, runner) as unknown as IDelegation;
  }
}
